"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    return {
        vMiddle: { verticalAlign: "middle" },
        relative: { position: "relative" },
        absolute: { position: "absolute", left: 0, top: 0 },
        fixed: { position: "fixed" }
    };
});
//# sourceMappingURL=Positional.js.map